<template>
    <div>
        <Table border ref="tableRef" :columns="columns" :data="tableData" :loading="tableLoading">
            <template slot="edit" slot-scope="{ row }">
                <Button icon="md-create" type="warning" size="small" @click="editPop(row)">编辑</Button>
            </template>
            <template slot="delete" slot-scope="{ row }">
                <Button icon="md-trash" type="error" size="small" @click="deletePop(row)">删除</Button>
            </template>
        </Table>
        <Row type="flex" justify="space-between" style="margin-top: 15px">
            <Col :xs="24" :sm="24" :lg="12">
                <Page :total="this.totalNum" style="margin-top: 0px;display: flex;justify-content: flex-start;margin-bottom:10px" @on-change="pageChange" />
            </Col>
            <Col :xs="24" :sm="24" :lg="12" class="btns" style="display:flex;justify-content:end;">
                <Button type="primary" icon="md-add" @click="add">新增</Button>
            </Col>
        </Row>

        <Modal v-model="modalPop"  :title="editState?'编辑':'新增'" >
           <Form :model="modalData" ref="modalDataRules" :label-width="120" label-position="left" label-colon :rules="ruleValidate">
                <FormItem label="关联部门" prop="qaOrg">
                    <Input v-model="modalData.qaOrg" />
                </FormItem>
                <FormItem label="角色" prop="qaRoleId">
                    <Select v-model="modalData.qaRoleId" >
                        <Option v-for="(item,index) in roleList" :value="item.roleId" :key="index">{{ item.roleName }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="联系方式" prop="qaTelNum">
                    <Input v-model="modalData.qaTelNum" />
                </FormItem>
            </Form>
            <div class="bottomBtn" slot="footer">
                <Button @click="cancel()">取消</Button>
                <Button type="primary" @click="saveData()" style="margin-left:15px">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            tableLoading:false,
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            modalPop:false,
            columns:[
                {
                    title: '关联部门',
                    key: 'qaOrg',
                    align: "center",
                    minWidth:120
                },
                {
                    title: '角色（可回复）',
                    align: "center",
                    key: 'qaRoleId',
                    minWidth:120,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.roleList.filter(el => el.roleId==params.row.qaRoleId).map(item => item.roleName)
                        );
                    },
                },
                {
                    title: '联系方式',
                    align: "center",
                    key: 'qaTelNum',
                    minWidth:120
                },
                {
                    title: '编辑',
                    align: "center",
                    slot: "edit",
                    width:120
                },{
                    title: '删除',
                    align: "center",
                    slot: "delete",
                    width:120
                }
            ],
            ruleValidate: {
                qaOrg: [
                    { required: true, message: '关联部门不能为空', trigger: 'blur' }
                ],
                qaRoleId: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ],
                qaTelNum: [
                    { required: true, message: '不能为空', trigger: 'blur' }
                ],
            },
            tableData:[],
            editState:false,
            modalData:{
                qaOrg:'',
                qaRoleId:'',
                qaTelNum:""
            },
            roleList:[],
        }
    },
    created(){
        this.getRoleData()
        this.getData()
    },
    methods:{
        getData(){
            this.tableLoading=true
            axios.post('/qaMasterSet/selectQaMasterSet',{...this.pageInfo}).then(res => {
                this.tableLoading=false
                if(res) {
                    this.tableData=res.data
                    this.totalNum=Number(res.pageInfo.total)
                }
            })
        },
        getRoleData(){
            axios.post('/remindModule/selectAllRemindRoleData',{remindId:''}).then(res => {
                if(res) {
                    this.roleList=res
                }
            })
        },
        editPop(row){
            this.editState=true
            this.modalData=JSON.parse(JSON.stringify(row))
            this.modalPop=true
        },
        deletePop(row){
            this.$Modal.confirm({
                title: this.$notice('deletion'),
                onOk: () => {
                    axios.post('/qaMasterSet/deleteQaMasterSet',{qaOrg:row.qaOrg}).then(res => {
                        if(res) {
                            this.$Message.success('删除成功');
                            this.getData()
                        }
                    })
                }
            });
        },
        add(){
            this.editState=false
            this.modalPop=true
        },
        saveData(){
            this.$refs.modalDataRules.validate((valid) => {
                if (valid) {
                    this.$Modal.confirm({
                        title: this.$notice('sureSave'),
                        onOk: () => {
                            if(this.editState){
                                this.editData()
                            }else{
                                this.addData()
                            }
                        }
                    });
                   
                } 
            })
        },
        //新增
        addData(){
            axios.post('/qaMasterSet/insertQaMasterSet',this.modalData).then(res => {
                if(res) {
                    this.$Message.success('新增成功');
                     this.modalPop=false
                     this.$refs.modalDataRules.resetFields();
                     this.getData()
                }
            })
        },
        //编辑
        editData(){
            axios.post('/qaMasterSet/updateQaMasterSet',this.modalData).then(res => {
                if(res) {
                    this.$Message.success('修改成功');
                     this.modalPop=false
                     this.$refs.modalDataRules.resetFields();
                     this.getData()
                }
            })
        },
        cancel(){
            this.modalPop=false
            this.$refs.modalDataRules.resetFields();
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/QaMasterSet.vue